import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';

export interface NewplaAiKnowledgeListDto {
  id: string;
  category: string | null;
  title: string;
  summary: string | null;
  markdown: boolean;
  enabled: boolean;
  length: number;
  updatedAt: string;
  updatedByName: string | null;
}

export interface NewplaAiKnowledgeDto {
  id: string | null;
  category: string | null;
  title: string;
  summary: string | null;
  content: string;
  markdown: boolean;
  enabled: boolean;
  createdAt?: string | null;
  createdByName?: string | null;
  updatedAt?: string | null;
  updatedByName?: string | null;
}

/** AI 지식 관리 API (/api/newpla-ai/knowledge) */
@Injectable({ providedIn: 'root' })
export class NewplaAiKnowledgeApi {

  private readonly baseUrl = '/api/newpla-ai/knowledge';
  private http = inject(HttpClient);

  findList(keyword: string, category: string): Promise<NewplaAiKnowledgeListDto[]> {
    let params = new HttpParams();
    if (keyword.trim()) {
      params = params.set('keyword', keyword.trim());
    }
    if (category) {
      params = params.set('category', category);
    }
    return lastValueFrom(this.http.get<NewplaAiKnowledgeListDto[]>(this.baseUrl, { params }));
  }

  findCategories(): Promise<string[]> {
    return lastValueFrom(this.http.get<string[]>(`${this.baseUrl}/categories`));
  }

  get(id: string): Promise<NewplaAiKnowledgeDto> {
    return lastValueFrom(this.http.get<NewplaAiKnowledgeDto>(`${this.baseUrl}/${id}`));
  }

  create(form: NewplaAiKnowledgeDto): Promise<NewplaAiKnowledgeDto> {
    return lastValueFrom(this.http.post<NewplaAiKnowledgeDto>(this.baseUrl, form));
  }

  update(id: string, form: NewplaAiKnowledgeDto): Promise<NewplaAiKnowledgeDto> {
    return lastValueFrom(this.http.put<NewplaAiKnowledgeDto>(`${this.baseUrl}/${id}`, form));
  }

  delete(id: string): Promise<void> {
    return lastValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`));
  }
}
